import React, { useEffect, useState } from 'react'
import { Button, Col, Row, notification, Drawer, Form, Modal } from 'antd'
import { useDispatch } from 'react-redux'
import { addNewAssessmentFxn } from '../action/index'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { CountryCodeWithFlag } from '../../../components/_utils/countryUtil'
import { listAllCountries } from '../../countries/actions/countries'
import { countryIds, InputBox } from '../../../components/_utils/appUtils'
import { getUser } from '../../users/actions/user'
import { getLoginUser } from '../../../request'

const AddNewAssessment = (props) => {
  const {
    form: { getFieldDecorator, setFieldsValue }, visible, onClose, onSubmit
  } = props
  const dispatch = useDispatch()
  let currentUser = getLoginUser()
  let [countryCode, setCountryCode] = useState('')
  let [documents, setDocuments] = useState([])
  let [countries, setCountries] = useState([])
  let [userData, setUserData] = useState([])
  const [congratsModalObj, setCongratsModalObj] = useState({
    visible: false,
    assessmentData: {}
  })

  const loadCurrentUser = async () => {
    let data = await dispatch(getUser(currentUser._id))
    setUserData(data)
  }

  const loadCountries = async () => {
    let obj = {
      results: 100,
      active: true,
      select: 'countryName'
    }
    let { data } = await dispatch(listAllCountries(obj))
    setCountries(data)
  }

  useEffect(() => {
    loadCountries()
    loadCurrentUser()
  }, [currentUser._id])


  useEffect(() => {
    loadCurrentUser()
    setTimeout(() => {
      props.form.setFieldsValue({
        countryId: countryIds.uk,
        contactPersonName: userData.name,
        contactNumber: userData.mobile
      })
      setCountryCode(userData.countryCode)
    }, 200)
  }, [userData._id])


  const handleSubmit = (e) => {
    e.preventDefault()
    props.form.validateFields(async (err, valData) => {
      if (!err) {
        if (!valData.countryId) {
          return notification.warning({
            message: 'Please choose country'
          })
        }
        if (!countryCode) {
          return notification.warning({
            message: 'Please choose country code'
          })
        }
        if (documents.length === 0) {
          return notification.warning({
            message: 'Please select at least one document'
          })

        }
        valData.countryCode = countryCode
        valData.documents = documents
        if (userData && userData._id) {
          valData.agentId = userData._id
        }
        let fd = new FormData()
        fd.append('obj', JSON.stringify(valData))

        documents.forEach((file, index) => {
          fd.append('documents', file)
        })
        const response = await dispatch(addNewAssessmentFxn(fd))
        if (!response.error) {
          notification.success({ message: 'Assessment submitted successfully' })
          setCongratsModalObj({
            visible: true, assessmentData: response.data
          })
        } else {
          notification.error({ message: response.message || 'Submission failed' })
        }
      }
    })
  }
  const handleFileChange = (files) => {
    setDocuments(files)
  }

  const inputTypes = {
    fields: [
      {
        key: 'countryId',
        label: 'Countries',
        label1: 'Select Country',
        type: 'select',
        showSearch: true,
        options: countries,
        disabled: true,
        keyAccessor: x => x._id,
        valueAccessor: x => `${x.countryName}`,
        onChange: x => {
          setFieldsValue({
            countryId: x
          })
        },
        span: 12
      },
      {
        key: 'studentName',
        label: 'Full Name',
        required: true,
        placeholder: 'Enter full name',
        span: 12
      },
      {
        key: 'passportNumber',
        label: 'Passport Number',
        required: true,
        placeholder: 'Enter passport number',
        span: 12
      },
      {
        key: 'dateOfBirth',
        label: 'Date of Birth',
        required: true,
        type: 'date',
        span: 12
      },
      {
        key: 'contactPersonName',
        label: 'Agent Name',
        required: true,
        placeholder: 'Enter agent name',
        span: 24
      },
      {
        key: 'countryCode',
        customField: (
          <div className={'mt10'}>
            <CountryCodeWithFlag
              countryCode={countryCode}
              chooseCode={(val) => {
                setCountryCode(val)
              }} />
          </div>
        ),
        span: 12
      },
      {
        key: 'contactNumber',
        label: 'Contact Number',
        required: true,
        placeholder: 'Enter contact number',
        span: 12
      },
      {
        key: 'documents',
        label: 'Documents',
        name: 'Documents',
        type: 'file',
        multiple: true,
        value: documents,
        customField: (
          <InputBox title={'Documents'} className={'rowFlex'}>
            <input
              type='file'
              name='documents'
              id='documents'
              className='form-control'
              multiple
              onChange={(e) => {
                handleFileChange(e.target.files ? Array.from(e.target.files) : [])
              }}
            />
          </InputBox>
        ),
        span: 24
      },
      {
        key: 'documents',
        label: 'Documents',
        name: 'Documents',
        type: 'file',
        multiple: true,
        value: documents,
        span: 24,
        customField: (
          <div className='document_box' style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
            {documents && documents.length
              ? documents.map((item, index) => {
                return (
                  <div key={index} className='doc-preview-card pCursor' style={{ position: 'relative' }}>
                    {/* Cross icon */}
                    <span
                      onClick={() => {
                        const updatedDocs = documents.filter((_, i) => i !== index)
                        setDocuments(updatedDocs) // ← make sure setDocuments is defined
                      }}
                      style={{
                        position: 'absolute',
                        top: '4px',
                        right: '4px',
                        cursor: 'pointer',
                        background: '#fff',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        boxShadow: '0 0 4px rgba(0,0,0,0.2)'
                      }}
                    >
                  ×
                </span>
                    <img src='../images/google-docs.png' alt='DOC' className='doc-card-icon' />
                    <div className='doc-card-name'>
                      {item.name
                        ? `${item.name.slice(0, 6)}...${item.name.slice(item.name.lastIndexOf('.'))}`
                        : 'Untitled'}
                    </div>
                  </div>
                )
              })
              : null}
          </div>
        )
      }
    ]
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 }
    }
  }

  return (
    <>
      <Drawer
        visible={visible}
        onClose={onClose}
        width={'42%'}
        title={'Add Assessment'}
      >
        <div className='row'>
          <div className='col-lg-12'>
            <div className='card unizportal'>
              <Form>
                <Row gutter={12}>
                  {inputTypes.fields.map((item, index) => {
                    if (item.hidden) return null

                    return (
                      <Col span={item.span ? item.span : 8} key={item.key || index}>
                        {item.customField ? item.customField : (
                          <GetEachFormFields
                            item={item}
                            getFieldDecorator={getFieldDecorator}
                            formItemLayout={formItemLayout}
                          />
                        )}
                      </Col>
                    )
                  })}
                </Row>
                <div className='d-flex justify-content-between mt-4'>
                  <button className='btn' type='submit' onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </Form>


            </div>
          </div>
        </div>
      </Drawer>


      {/* 🎉 Congratulations Modal */}
      {congratsModalObj.visible ?
        <Modal
          visible={congratsModalObj.visible}
          footer={null}
          closable={false}
          centered
          width={'40%'}
        >
          <div className='text-center'>
            <img src={'/images/congrats.png'} className={'congratsImage'} />
            <div className={'welcomeSuccessText'}> Congratulations!</div>
            <div className={'companySuccessText'}>Your assessment has been received.</div>
            {congratsModalObj && congratsModalObj.assessmentData && congratsModalObj.assessmentData.referenceNumber ?
              <div className={'referenceText'}>
                Your Reference Number is {congratsModalObj.assessmentData.referenceNumber}
              </div> : null}
            <button
              className={'backToAssessmentBtn'}
              onClick={() => {
                setCongratsModalObj({
                  visible: false,
                  assessmentData: {}
                })
                onClose()
                onSubmit()
              }}>
              Back to Assessments
            </button>
          </div>
        </Modal> : null}
    </>
  )
}
export default Form.create()(AddNewAssessment)
